import { render, staticRenderFns } from "./PreventiveHealthAndVacination.vue?vue&type=template&id=4d6e63a9&scoped=true&"
import script from "./PreventiveHealthAndVacination.vue?vue&type=script&lang=js&"
export * from "./PreventiveHealthAndVacination.vue?vue&type=script&lang=js&"
import style0 from "./PreventiveHealthAndVacination.vue?vue&type=style&index=0&id=4d6e63a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6e63a9",
  null
  
)

export default component.exports